function App() {
  return (
    <div>
      <img alt="logo" src="/logo512.png" />
      <h1>Budujemy marzenia</h1>
      <p>Strona w budowie</p>
    </div>
  );
}

export default App;
